const COLORS = [
  '#00930e',
  '#b20040',
  '#bfaf00',
  '#3c2bd2',
  '#870095',
  '#3d0065',
  '#42a4f3',
  '#86bb6a',
  '#d600b1',
  '#814900',
  '#ff61b2',
  '#00035b',
  '#ff7e47',
  '#ff7e47',
  '#a98900',
  '#ff4e64',
  '#E3C0D3',
  '#1B9AAA',
  '#FFC43D',
  '#F8FFE5',
  '#3F7CAC',
  '#E2F89C',
  '#2C3D55',
  '#6A687A',
  '#3E4C5E',
  '#CDC1FF',
  '#42E2B8',
  '#FCFF4B',
  '#6D435A',
  '#352D39',
  '#580C1F',
  '#697A21',
  '#7D80DA',
  '#7B886F',
  '#93827F',
  '#001514',
  '#034732',
  '#232E21',
  '#9B2915',
  '#944BBB',
  '#DB5375',
  '#FEB95F',
  '#23CE6B'
]

export default function getColor(number) {
  if (number > COLORS.length) return COLORS[number % COLORS.length]
  return COLORS[number]
}
